import {Status} from "../store/types/general";
import {convertToJson, isResponseOk} from "../helpers/RequestHelper";

export const GeneralService = {

    getStatus(key: string): Promise<Status | null> {
        const url = `/lmakort/status?key=${key}`;
        return fetch(url, {
            headers: { 'Content-Type': 'application/json; charset=utf-8' },
            method: 'get'
        })
            .then(res => isResponseOk(res))
            .then(res => convertToJson(res))
    }
};
